const BINDING_ROW_HEIGHT = 36
const BINDINGS_MARGIN = 8

function isBoundParam(param: unknown): boolean {
  return !!param && typeof param === 'object' && 'bind' in param
}

/** Count Vega-Lite params that render HTML input widgets (select, range, etc.). */
export function getBoundParamCount(spec: unknown): number {
  if (!spec || typeof spec !== 'object') return 0

  const record = spec as Record<string, unknown>
  let count = 0

  if (Array.isArray(record.params)) {
    count += record.params.filter(isBoundParam).length
  }

  if (Array.isArray(record.layer)) {
    for (const layer of record.layer) {
      count += getBoundParamCount(layer)
    }
  }

  if (record.spec) {
    count += getBoundParamCount(record.spec)
  }

  if (Array.isArray(record.hconcat)) {
    for (const part of record.hconcat) {
      count += getBoundParamCount(part)
    }
  }

  if (Array.isArray(record.vconcat)) {
    for (const part of record.vconcat) {
      count += getBoundParamCount(part)
    }
  }

  return count
}

export function getEstimatedBindingsOffset(spec: unknown): number {
  return getBoundParamCount(spec) * BINDING_ROW_HEIGHT + BINDINGS_MARGIN
}

export function getChartPlotHeight(containerHeight: number, bindingsOffset: number): number {
  return Math.max(containerHeight - bindingsOffset, 120)
}
